/* Opus collection tabs: accessible tabs; the first tab is server-rendered, the rest load on first open
   from /collections/<handle>?view=opus-tab. Arrows scroll the tab strip and the product row. */
(() => {
  const cache = new Map();
  const load = (url) => {
    if (!cache.has(url)) cache.set(url, fetch(url).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }));
    return cache.get(url);
  };
  const syncArrows = (scroller, prev, next) => {
    if (!scroller) return;
    const max = scroller.scrollWidth - scroller.clientWidth - 2;
    if (prev) prev.hidden = scroller.scrollLeft <= 2;
    if (next) next.hidden = scroller.scrollLeft >= max;
  };
  const wire = (scroller, root) => {
    if (!scroller || scroller.dataset.opusWired) return;
    scroller.dataset.opusWired = '1';
    const kind = scroller.hasAttribute('data-opus-rail') ? 'rail' : 'tabs';
    const prev = root.querySelector(`[data-opus-scroll="${kind}"][data-dir="-1"]`);
    const next = root.querySelector(`[data-opus-scroll="${kind}"][data-dir="1"]`);
    const update = () => syncArrows(scroller, prev, next);
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    [prev, next].forEach((b) => b && b.addEventListener('click', () => scroller.scrollBy({ left: Number(b.dataset.dir) * scroller.clientWidth * 0.85, behavior: 'smooth' })));
    update();
    scroller._opusUpdate = update;
  };
  const init = (section) => {
    if (section.dataset.opusTabsReady) return;
    section.dataset.opusTabsReady = '1';
    const tabs = [...section.querySelectorAll('[data-opus-tab]')];
    const panels = [...section.querySelectorAll('[data-opus-panel]')];
    wire(section.querySelector('[data-opus-tablist]'), section.querySelector('.opus-tabs__bar'));
    const panelOf = (id) => panels.find((p) => p.dataset.opusPanel === id);
    const fill = async (panel) => {
      const rail = panel.querySelector('[data-opus-rail]');
      if (rail.children.length || rail.dataset.loading) { wire(rail, panel); rail._opusUpdate && rail._opusUpdate(); return; }
      rail.dataset.loading = '1';
      rail.classList.add('opus-tabs__rail--loading');
      try {
        const html = await load(panel.dataset.url);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('[data-opus-tab-cards] > li');
        rail.replaceChildren(...[...items].map((li) => document.importNode(li, true)));
      } catch (e) {
        rail.innerHTML = '<li class="opus-tabs__empty">Couldn\'t load these products. Try again.</li>';
      } finally {
        delete rail.dataset.loading;
        rail.classList.remove('opus-tabs__rail--loading');
        rail.scrollLeft = 0;
        wire(rail, panel);
        rail._opusUpdate && rail._opusUpdate();
      }
    };
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const p = panelOf(t.dataset.opusTab);
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      const p = panelOf(tab.dataset.opusTab);
      if (p) fill(p);
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t, false));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        select(tabs[(i + d + tabs.length) % tabs.length], true);
      });
      // Warm the next tabs' products on hover so opening feels instant.
      t.addEventListener('pointerenter', () => { const p = panelOf(t.dataset.opusTab); if (p) load(p.dataset.url).catch(() => {}); }, { once: true });
    });
    const firstPanel = panels.find((p) => !p.hidden);
    if (firstPanel) { wire(firstPanel.querySelector('[data-opus-rail]'), firstPanel); }
  };
  const boot = () => document.querySelectorAll('[data-opus-tabs]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', (e) => {
    const tab = e.target.closest && e.target.closest('[data-opus-tab]');
    if (tab) tab.click();
  });
})();
